// ComparePlayers.js
import React, { useState, useEffect } from 'react';
import { View, Text, Image, ImageBackground } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useSelector } from 'react-redux';
import transl from './../translations/transl';
import GlobalStyles from './../style';
import Graph from '../SpiderGraph';
import dr from './../datosReferenciales.json';

const ComparePlayers = () => {
  // Redux: índice y código de idioma
  const reduxLangIndex = useSelector((state) => state.language);
  const langCode = dr.idiomas[reduxLangIndex]?.value || dr.idiomas[0].value;

  // Datos del equipo y jugadores
  const [teamData, setTeamData] = useState(null);
  const [playerItems, setPlayerItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openPlayers, setOpenPlayers] = useState(false);

  // 1) Carga inicial de AsyncStorage
  useEffect(() => {
    (async () => {
      const raw = await AsyncStorage.getItem('equipos');
      if (!raw) return;
      const data = JSON.parse(raw);
      const team = data.teams?.[0];
      if (!team) return;
      setTeamData(team);

      // Genera items para el picker
      setPlayerItems(
        team.players.map((p, i) => ({ label: p.name, value: i }))
      );
      setSelectedIndex(0);
    })();
  }, []);

  // 2) Muestra loading si no hay datos
  if (!teamData) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Image
          style={{ width: 200, height: 200 * 0.6 }}
          source={require('./../img/loading.gif')}
        />
      </View>
    );
  }

  // Datos del jugador seleccionado
  const player = teamData.players[selectedIndex];
  const sumaHabilidades = (
    (player.skills[4] + player.broom[0] + player.broom[1] + player.broom[2] +
      player.skills[5] + player.skills[6] + player.skills[2] + player.skills[1] +
      player.skills[3] + player.skills[0]) /
    10
  ).toFixed();

  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        source={require('./../img/background5.png')}
        resizeMode="cover"
        style={{ flex: 1 }}
      >
        <Text style={[GlobalStyles.textForTitleScreen, { marginVertical: 30 }]}>  
          {transl('HomeScreen.compararJugadores', langCode)}
        </Text>

        <View style={{ marginTop: 25, marginHorizontal: 25, zIndex: 2000 }}>
          <DropDownPicker
            open={openPlayers}
            value={selectedIndex}
            items={playerItems}
            setOpen={setOpenPlayers}
            setValue={setSelectedIndex}
            setItems={setPlayerItems}
            placeholder={transl('General.seleccionaJugador', langCode)}
            listMode="SCROLLVIEW"
          />
        </View>

        <View style={{ alignItems: 'center', marginTop: 20 }}>
          <Graph
            graphSize={400}
            scaleCount={4}
            numberInterval={2}
            data={[
              {
                [transl('Roster.resistencia', langCode)]: player.skills[4] / 100,
                [transl('Roster.velocidad', langCode)]: player.broom[0] / 100,
                [transl('Roster.maniobra', langCode)]: player.broom[1] / 100,
                [transl('Roster.estabilidad', langCode)]: player.broom[2] / 100,
                [transl('Roster.vision', langCode)]: player.skills[5] / 100,
                [transl('Roster.comunicacion', langCode)]: player.skills[6] / 100,
                [transl('Roster.manejo', langCode)]: player.skills[2] / 100,
                [transl('Roster.reflejos', langCode)]: player.skills[1] / 100,
                [transl('Roster.fuerza', langCode)]: player.skills[3] / 100,
                [transl('Roster.precision', langCode)]: player.skills[0] / 100,
              },
            ]}
            options={{
              graphShape: 1,
              showAxis: true,
              showIndicator: false,
              colorList: ['black'],
              dotList: [false],
            }}
          />

          <View style={{ marginTop: 20 }}>
            <Text style={GlobalStyles.textH2}>
              {transl('League.mediaHabilidades', langCode)}: {sumaHabilidades}
            </Text>
            <Text style={GlobalStyles.textH2}>
              {transl('Statistics.edad', langCode)}: {player.age}
            </Text>
          </View>
        </View>
      </ImageBackground>
    </View>
  );
};

export default ComparePlayers;
